<template>
    <gofix-card :title="titleTable" class="finance-budget-card-table" classHeader="pl-19" classContent="mb-0" fullContent>
        <!-- class="card-list-tracking"  -->
        <!-- gofix-default-table -->
        <gofix-table :settings="tableConfig"
            :table-items="tableItems"
            @load-items="getTableData"
            ref="gofixTable">
            <template slot="gofix_table:edit" slot-scope="row">
                <button 
                    v-if="HeaderItem.status == 'Draft' || (HeaderItem.status == 'Approved' && row.item.entry_type !== 'Planned')"
                    type="button" 
                    class="icon-button position-relative"
                    @click="handleShowModalEdit(row.item)">
                    <img width="20" src="img/iconPencil.png" alt="" />
                </button>
            </template>
            <template slot="gofix_table:fm_code" slot-scope="row">
                <div class="d-flex">
                    <span class="mr-14 col px-0">{{ row.item.fm_code }}</span>
                    <!-- <span class="col px-0">{{ row.item.entry_type }}</span> -->
                </div>
            </template>
            <template slot="gofix_table:total_allocated" slot-scope="row">
                {{ row.item.total_allocated| formatMoney }}
            </template>
            <template slot="gofix_table:total_committed" slot-scope="row">
                {{ row.item.total_committed| formatMoney }}
            </template>
            <template slot="gofix_table:total_actual" slot-scope="row">
                {{ row.item.total_actual| formatMoney }}
            </template>
            <template slot="gofix_table:variance" slot-scope="row">
                {{ row.item.variance| formatMoney }}
            </template>
            <template :slot="`gofix_table:${item.label}`" v-for="(item, index) in dynamicFields" slot-scope="row">
                <router-link :key="index" target="_blank" class="text-dark" :to="`/v2/budget/${row.item.budget_header_id}/budget-tracking/detail?fm_code=${row.item.fm_code_id}&calendar_month=${row.item.month_year[item.index].calendar_month}`">
                    <span v-if="row.item.month_year[item.index]">
                        <template v-if="item.label.indexOf('committed') != -1">
                            {{ row.item.month_year[item.index].committed_amount | formatMoney }}
                        </template>
                        <template v-else>
                            {{ row.item.month_year[item.index].actual_amount | formatMoney }}
                        </template>
                    </span>
                </router-link>
            </template>
        </gofix-table>
    </gofix-card>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js';
    import moment from 'moment';
    const fieldDefault = [
        {
            key: 'fm_code',
            label: 'FM Code',
            thStyle: "width:150px",
            isActive: 1,
            isFilter: true,
            sorting: true
        },
        {
            key: 'description',
            label: 'Description',
            thStyle: "width:170px",
            isActive: 1,
            isFilter: true,
            sorting: true
        },
        {
            key: 'gl_code',
            label: 'GL Code',
            isActive: 1,
            thStyle: "width:110px",
            isFilter: true,
            sorting: true
        },
        {
            key: 'root_path_properties',
            label: 'Property',
            isActive: 1,
            thStyle: "width:200px",
            isFilter: true,
            sorting: true
        },
        {
            key: 'name_service',
            label: 'Service Category',
            isActive: 1,
            thStyle: "width:150px",
            isFilter: true,
            sorting: true
        },
        {
            key: 'work_type',
            label: 'Work Type',
            isActive: 1,
            thStyle: "width:110px",
            isFilter: true,
            sorting: true
        }
    ];

    const columns = [
        {
            key: 'total_allocated',
            label: 'Budget',
            isActive: 1,
            thStyle: "width:150px",
            thClass: 'text-right',
            tdClass: 'text-right',
            isFilter: false,
            sorting: false
        },
        {
            key: 'total_committed',
            label: 'Total Committed',
            isActive: 1,
            thStyle: "width:130px",
            thClass: 'text-right',
            tdClass: 'text-right',
            isFilter: false,
            sorting: false
        },
        {
            key: 'total_actual',
            label: 'Total Actual',
            isActive: 1,
            thStyle: "width:130px",
            thClass: 'text-right',
            tdClass: 'text-right',
            isFilter: false,
            sorting: false
        },
        {
            key: 'variance',
            label: 'Variance',
            isActive: 1,
            thStyle: "width:120px",
            thClass: 'text-right',
            tdClass: 'text-right',
            isFilter: false,
            sorting: false
        }
    ]

    export default {
        name: 'budget-entries',
        components: {},
        props: {
            titleTable: {
                type: String,
                default: ''
            },
            category: {
                type: String,
                default: ''
            }
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['budget_entries']));
            return {
                totalSumDate: [],
                tableItems: [],
                tableConfig:{
                    name: 'budget-entries',
                    controls:{
                        create: false,
                        delete: false,
                        tableImport: false,
                        tableExport: false,
                        tableColumnSettings: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    fields: JSON.parse(JSON.stringify(fieldDefault))
                },
                dynamicFields: []
            }
        },
        computed: {
            ...mapGetters({
                HeaderItem: 'BudgetAllocationController/headerItem',
            })
        },
        watch: {
            HeaderItem: function(val, old) {
                if(val) {
                    this.$refs.gofixTable.reloadTableItems();
                    this.getColumnSettings();
                }
            }
        },
        methods: {
            getColumnSettings() {
                if(this.HeaderItem && this.HeaderItem.financial_year_start) {
                    var dateStart = moment(this.HeaderItem.financial_year_start);
                    var dateEnd = moment(this.HeaderItem.financial_year_start).add(11, 'M');
                    var timeValues = [];
                    let fields = [...columns];
                    let index = 0;
                    while (dateEnd > dateStart || dateStart.format('M') === dateEnd.format('M')) {
                        fields = [...fields, ...[
                            {
                                key: `committed_${dateStart.format('YYYY-MM')}`,
                                label: `${dateStart.format('MMM, YYYY')} (Committed)`,
                                thStyle: "width:120px",
                                thClass: 'bg-gray-e9e text-right',
                                tdClass: 'bg-gray-e9e text-right',
                                width: 200,
                                isActive: 1,
                                isFilter: false,
                                sorting: false
                            },
                            {
                                key: `actual_${dateStart.format('YYYY-MM')}`,
                                label: `${dateStart.format('MMM, YYYY')} (Actual)`,
                                thStyle: "width:120px",
                                thClass: 'text-right',
                                tdClass: 'text-right',
                                width: 200,
                                isActive: 1,
                                isFilter: false,
                                sorting: false
                            }
                        ]];
                        timeValues = [
                            ...timeValues,
                            ...[{
                                label: `committed_${dateStart.format('YYYY-MM')}`,
                                value: '',
                                index: index
                            },
                            {
                                label: `actual_${dateStart.format('YYYY-MM')}`,
                                value: '',
                                index: index
                            }]
                        ];
                        dateStart.add(1,'month');
                        index++;
                    }
                    this.dynamicFields = timeValues;
                    this.tableConfig.fields = [...fieldDefault, ...fields];
                    this.$refs.gofixTable.updateColumnSettings(this.tableConfig.fields);
                }
            },
            findSumFollowLabel(label) {
                if(!this.totalSumDate.length) return null;
                let arrTmp = this.totalSumDate.filter(item => moment(item.calendar_month).format('YYYY-MM') == label)
                if(arrTmp.length) {
                    return arrTmp[0].sum_calendar_month;
                }
                return null;
            },
            calculateTotalBudget(month_year) {
                if(!month_year.length) return 0;
                let total = 0;
                month_year.map(item => {
                    total += item.allocated_amount;
                })
                return total;
            },
            reloadItems(is_reload_list = true) {
                this.$store.dispatch("BudgetAllocationController/getHeaderItem", this.$route.params.id)
                .then(response => { })
                .catch(async err => {
                    await this.$router.push(`/v2/budget`);
                    await this.$alertNotification("Id does not exist", "danger");
                    reject();
                })

                if(is_reload_list)
                    this.$refs.gofixTable.reloadTableItems();
            },
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                if (!this.$route.params.hasOwnProperty('id') || this.$route.params.id == "0" || isNaN(this.$route.params.id)) {
                    resolve({
                        items: [],
                        total: 0
                    })
                    return
                }
                tableRequest.filter.budget_category.value = this.category;
                tableRequest.filter.budget_header_id.value = this.$route.params.id;
                await this.$store.dispatch("BudgetAllocationController/getBudgetTrackingEntries", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.totalSumDate = response.sum_date
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            }
        }
    }
</script>
